import React, {useState, useEffect} from "react";
import "./main_dashboard.css";
import Top_navbar from "./Top_navbar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImages } from '@fortawesome/free-regular-svg-icons';
import { decryptData } from "../../controllers/Encryption";
import { useNavigate } from "react-router-dom";
import { faBoxes, faBullhorn, faCircleUser, faCogs, faCubes, faFileInvoice, faFileInvoiceDollar, faGifts, faListCheck, faListNumeric, faMoneyBill, faMoneyBill1Wave, faMoneyBillTrendUp, faReceipt, faTicket, faTicketAlt, faTrophy, faUser, faWallet, faWarehouse } from "@fortawesome/free-solid-svg-icons";
const Dashboard = () => {
  const navigate = useNavigate();
  const user = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));
  const [PERMISSIONDATA, setPermissionData] = useState('');
  const handlePermission = async () =>{
    if(user && user.admin_type !== 'Super Admin'){
      const encrypted  = JSON.parse(sessionStorage.getItem("ADMIN-PERMISSION"));
      const decrypted  = await decryptData(encrypted);
      const permission = JSON.parse(decrypted);
      setPermissionData(permission);
    }
  }

  useEffect(()=>{
    if(sessionStorage.getItem("ADMIN-PERMISSION") !== 'undefined'){
      handlePermission();
    }
  },[]);

  const navigationBlock = [
    {
      link : `/users/list`,
      icon : faCircleUser,
      title : `Users`,
      Descriptions : `Navigate to user's list`,
      status : PERMISSIONDATA?.usersPermission?.list === 'Y'?'Y':'N'
    },
    {
      link : `/recharge/b-point-list`,
      icon : faMoneyBill,
      title : `Points`,
      Descriptions : `Navigate to Point recharge history`,
      status : PERMISSIONDATA?.rechargePoints?.list === 'Y'?'Y':'N'
    },
    {
      link : `/promocodes/list`,
      icon : faGifts,
      title : `Promo codes`,
      Descriptions : `Navigate to promo code's list.`,
      status : PERMISSIONDATA?.promoCodes?.list === 'Y'?'Y':'N'
    },
    {
      link : `/promocodes/order`,
      icon : faListCheck,
      title : `Promo Code Orders`,
      Descriptions : `Navigate to promo code order's list.`,
      status : PERMISSIONDATA?.promoCodesOrder?.list === 'Y'?'Y':'N'
    },
    {
      link : `/promocodes/vouchers/list`,
      icon : faTicket,
      title : `Promo Code Vouchers`,
      Descriptions : `Navigate to promo code voucher.`,
      status : PERMISSIONDATA?.promoCodesVoucher?.list === 'Y'?'Y':'N'
    },
    {
      link : `/product/list`,
      icon : faBoxes,
      title : `Products`,
      Descriptions : `Navigate to product's list.`,
      status : PERMISSIONDATA?.products?.list === 'Y'?'Y':'N'
    },
    {
      link : `/product/variants/list`,
      icon : faCubes,
      title : `Product's Variant`,
      Descriptions : `Navigate to product variant's list.`,
      status : PERMISSIONDATA?.productVariant?.list === 'Y'?'Y':'N'
    },
    {
      link : `/product/inventory/list`,
      icon : faWarehouse,
      title : `Product's Inventory`,
      Descriptions : `Navigate to product inventory's list.`,
      status : PERMISSIONDATA?.productInventory?.list === 'Y'?'Y':'N'
    },
    {
      link : `/product/order/list`,
      icon : faReceipt,
      title : `Product's Order`,
      Descriptions : `Navigate to product order's list.`,
      status : PERMISSIONDATA?.productOrder?.list === 'Y'?'Y':'N'
    },
    {
      link : `/campaign/list`,
      icon : faBullhorn,
      title : `Campaign`,
      Descriptions : `Navigate to campaign's list.`,
      status : PERMISSIONDATA?.campaign?.list === 'Y'?'Y':'N'
    },
    {
      link : `/campaign/order/list'`,
      icon : faListNumeric,
      title : `Campaign Order`,
      Descriptions : `Navigate to campaign order's list.`,
      status : PERMISSIONDATA?.campaignOrder?.list === 'Y'?'Y':'N'
    },
    {
      link : `/campaign/freezes`,
      icon : faCogs,
      title : `Campaign Freezes`,
      Descriptions : `Navigate to campaign freezes.`,
      status : PERMISSIONDATA?.campaignFreezes?.edit === 'Y'?'Y':'N'
    },
    {
      link : `/raffle-winners/list`,
      icon : faTrophy,
      title : `Raffle Winners`,
      Descriptions : `Navigate to raffle winner's list.`,
      status : PERMISSIONDATA?.raffleWinner?.list === 'Y'?'Y':'N'
    },
    {
      link : `/raffle-draw/list`,
      icon : faCubes,
      title : `Raffle Draws`,
      Descriptions : `Navigate to raffle draw's list.`,
      status : PERMISSIONDATA?.raffleDraw?.list === 'Y'?'Y':'N'
    },
    {
      link : `/lotto-winners/list`,
      icon : faMoneyBill1Wave,
      title : `Lotto Winners`,
      Descriptions : `Navigate to lotto winners's list.`,
      status : PERMISSIONDATA?.lottoWinner?.list === 'Y'?'Y':'N'
    },
    {
      link : `/lotto-winners/redeem-list`,
      icon : faMoneyBillTrendUp,
      title : `Lotto Redeemed`,
      Descriptions : `Navigate to lotto winner redeemed list.`,
      status : PERMISSIONDATA?.lottoRedeem?.list === 'Y'?'Y':'N'
    },
    {
      link : `/wallets-statement/list`,
      icon : faWallet,
      title : `Wallets Statement`,
      Descriptions : `Navigate to wallets statements.`,
      status : PERMISSIONDATA?.walletStatement?.list === 'Y'?'Y':'N'
    },
    {
      link : `/cms/general_data/addeditdata`,
      icon : faCogs,
      title : `General Details`,
      Descriptions : `general data.`,
      status : PERMISSIONDATA?.generalDataCMS?.edit === 'Y'?'Y':'N'
    },
    {
      link : `/cms/banner/list`,
      icon : faImages,
      title : `Manage Banners`,
      Descriptions : `Navigate to banner's list.`,
      status : PERMISSIONDATA?.bannerCMS?.list === 'Y'?'Y':'N'
    },
    {
      link : `/invoice/list`,
      icon : faFileInvoice,
      title : `Invoice`,
      Descriptions : `Navigate to individual invoice list.`,
      status : PERMISSIONDATA?.individualInvoice?.list === 'Y'?'Y':'N'
    },
    {
      link : `/invoice/bulk-list`,
      icon : faFileInvoiceDollar,
      title : `Bulk Invoice`,
      Descriptions : `Navigate to bulk invoice request.`,
      status : PERMISSIONDATA?.bulkInvoice?.list === 'Y'?'Y':'N'
    }
    
    
  ]

  
  return (
    <>
      <Top_navbar></Top_navbar>
      <div className="container-fluid">
        <div className="row">
          {(navigationBlock && navigationBlock.length > 0) && navigationBlock.map((items, index)=>(
            (user?.admin_type === 'Super Admin' || items?.status === 'Y') && (
              <div key={index} className="col-md-3 px-0" onClick={()=>navigate(`${items.link}`)}>
                <div className="transaction_form">
                  <div className="transaction_Card margin-right">
                    <span style={{marginLeft:'10px',marginRight:'10px'}}>  <FontAwesomeIcon icon={items.icon} className="sidebar_collapse_iohomeoutline" /></span>
                    <div className="transction_main_Card ">
                      <h1 className="dashboard_top_heading_user"> {items.title}</h1>
                    </div>
                    <p className="presentation my-2">
                      {items.Descriptions}
                    </p>
                  </div>
                </div>
              </div>
            )
          ))}
        </div>
      
      </div>
    </>
  );
};

export default Dashboard;
